import { Controller } from 'stimulus'
import flatpickr from 'flatpickr'

export default class extends Controller {
    static values = { minuteIncrement: Number }

    connect() {
        this.picker = flatpickr(this.element, {
            allowInput:      true,
            dateFormat:      'H:i',
            enableTime:      true,
            minuteIncrement: this.minuteIncrementValue || 1,
            noCalendar:      true,
            time_24hr:       true
        })
    }

    disconnect() {
        if (this.picker) {
            this.picker.destroy()
        }
    }
}
